<template>
  <section>
    <PageTitle title="Reservations" v-bind:crumbs="[{href:'/home',title:'Home'},{href:'/reservations',title:'All Reservations'}]" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <div class="row">
        <div class="col-lg-12">
          <div class="ibox-title">
            <h5 class="pull-left">All Reservations</h5>
            <a @click="addNewReservation()" class="pull-right">Add New Reservation</a>
          </div>
          <div class="ibox-content">
              <div class="row">
                <div class="col-md-4 form-group h-90">
                  <label>Email</label>
                  <input placeholder="Enter Customer Email" id="email" class="form-control custom_width" type="email" />
                </div>
                <div style="height: 90px" class="col-md-4">
                  <label>Restaurants</label>
                  <Multiselect id="filter1"
                               v-model="selectedRestaurant"
                               :options="allRestaurants"
                               :allow-empty="false"
                               label="name"
                               track-by="name"></Multiselect>
                </div>
                <div style="height: 90px" class="col-md-4">
                  <label>Branches <b v-if="!selectedRestaurant" class="text-danger text-sm">(select restaurant)</b></label>
                  <Multiselect id="filter2"
                               v-model="selectedBranch"
                               :options="allBranches"
                               label="name"
                               track-by="name"
                               :disabled="!selectedRestaurant"
                               placeholder="Select Restaurant Branch"></Multiselect>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4 form-group">
                  <search-customer-by-name-and-contact-number
                      ref="searchCustomerComponent"
                      :bayked-orders="false"
                      :is-deleted=customerDeleted
                      @selectedCustomer="(event) => this.selectedCustomerId = (event != null) ? event.id : null"
                  />
                </div>
                <div class="col-md-4 form-group h-90">
                  <label>Reservations Date</label>
                  <input id="date" type="text" readonly="readonly" placeholder="Search By Date Range" class="form-control date_picker"/>
                </div>
                <div class="col-md-4 h-90">
                  <button style="margin-top: 25px;margin-right: 10px" class=" btn btn-primary btn-sm search_btn" type="button"><i class="fa fa-search"></i> Search</button>
                  <button style="margin-top: 25px" class=" btn btn-info btn-sm refresh_btn"><i class="fa fa-refresh" type="button"></i> Refresh</button>
                </div>
              </div>
            <hr />
            <div class="table-responsive">
              <table class="table table-striped table-responsive table-bordered table-hover" id="dtTable">
                <thead>
                <tr>
                  <th>ID</th>
                  <th>Customer Name</th>
                  <th>Contact</th>
                  <th>Email</th>
                  <th>Restaurant</th>
                  <th>Branch</th>
                  <th>Number of Person</th>
                  <th>Special Request</th>
                  <th>Reservation Date</th>
                  <th>Created</th>
                  <th>Modified</th>
                  <th>Status</th>
<!--                  <th class="text-center"><i class="fa fa-bolt"></i></th>-->
<!--                  <th class="text-center"><i class="fa fa-user-times"></i></th>-->
                </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ChangeStatusOfReservation :statuses="statuses" ref="changeReservationStatus" />
  </section>
</template>

<script>
import PageTitle from "@/components/layout_components/PageTitle.vue";
import Multiselect from "vue-multiselect";
import SearchCustomerByNameAndContactNumber from "@/components/utils/SearchCustomerByNameAndContactNumber.vue";
import {getAllBranchesOfRestaurant, getAllRestaurant} from "@/api/restaurants";
import moment from "moment/moment";
import ChangeStatusOfReservation from "@/components/Reservations/ChangeStatusOfReservation.vue";

export default {
  name: "Reservations",
  components: {ChangeStatusOfReservation, SearchCustomerByNameAndContactNumber, Multiselect, PageTitle},
  data: function () {
    return {
      dtTable: null,
      customerDeleted: "No",
      selectedCustomerId: "",
      selectedRestaurant: null,
      allRestaurants: [],
      allBranchesObject: [],
      statuses: [],
      selectedBranch: null,
    };
  },
  computed: {
    allBranches() {
      return this.allBranchesObject.map((item) => {
        return {
          "id": item.id,
          "name": item.areasByAreaId.name,
        };
      })
    }
  },
  watch: {
    selectedRestaurant: async function () {
      if (this.selectedRestaurant !== null) {
        let params = new URLSearchParams();
        params.append("restaurant_id", this.selectedRestaurant.id);
        let restaurantBranches = await getAllBranchesOfRestaurant(params);
        this.allBranchesObject = restaurantBranches.data;
        this.selectedBranch = null;
      }
    }
  },
  created() {
    this.$http.get(this.$store.state.mainAppURL + "statuses/get_all_statuses").then(resp => {
      this.statuses = resp.data;
    });
  },
  mounted: async function () {
    await this.fetchRestaurantsAndBranches();
    await this.initializeDataTable();
    await this.jQueryOnRefreshAndSearchBtn();
    this.initializeAndResetDateRange()

  },
  methods: {
    addNewReservation () {
      this.$router.push({ name: 'NewReservation' });
    },
    async fetchRestaurantsAndBranches() {
      this.loggedInRole = this.$store.getters.user.userRolesById[0].role;
      if (this.loggedInRole === 'ROLE_USER' || this.loggedInRole === 'ROLE_FRANCHISE') {
        let user_restaurant = this.$store.getters.user.restaurant;
        this.selectedRestaurant = user_restaurant;
        let params = new URLSearchParams();
        params.append("restaurant_id", user_restaurant.id);
        let resp = await getAllBranchesOfRestaurant(params);
        this.allBranchesObject = resp.data;
      } else {
        let resp = await getAllRestaurant();
        this.allRestaurants = resp.data;
      }
    },
    jQueryOnRefreshAndSearchBtn() {
      let self = this;
      $(".search_btn").click(function () {
        self.resetData();
        // var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
        // if ($("#email").val() && !emailReg.test($("#email").val())) {
        //   return;
        // }
        if (self.selectedCustomerId) {
          self.dtTable.column(0).search(self.selectedCustomerId);
        }
        if (self.selectedRestaurant !== null) {
          self.dtTable.column(1).search(self.selectedRestaurant.id);
        }
        if (self.selectedBranch !== null) {
          self.dtTable.column(2).search(self.selectedBranch.id);
        }
        self.dtTable.column(3).search($("#email").val());
        self.dtTable.column(4).search($("#date").val());
        self.dtTable.draw();
      });
      $(".refresh_btn").click(function () {
        self.initializeAndResetDateRange()
        self.resetData();
        self.selectedBranch = null;
        if (self.loggedInRole !== 'ROLE_USER' && self.loggedInRole !== 'ROLE_FRANCHISE') {
          self.selectedRestaurant = null;
          self.allBranchesObject = [];
        }
        self.$refs.searchCustomerComponent.selectedCustomerTemp = ""
        self.selectedCustomer = ""
        $("#email").val('');
        $("#date").val('');
        self.dtTable.draw();
      });
    },
    resetData() {
      let self = this;
      self.dtTable.column(0).search('');
      self.dtTable.column(1).search('');
      self.dtTable.column(2).search('');
      self.dtTable.column(4).search('');
      self.dtTable.column(7).search('');
      self.dtTable.column(8).search('');
    },

    initializeAndResetDateRange() {
      $('.date_picker').daterangepicker({
        format: 'YYYY-MM-DD',
        maxDate: moment().add(6, 'M'),
        minDate: moment().subtract(6,'M')
      }).on('apply.daterangepicker', function(ev, picker) {
        $(this).val(picker.startDate.format('YYYY-MM-DD') + ' <==> ' + picker.endDate.format('YYYY-MM-DD'));
      }).on('cancel.daterangepicker', function(ev, picker) {
        $(this).val('');
      });
    },

    initializeDataTable() {
      let self = this;
      let processingURL = this.$store.state.mainAppURL + "reservations/all";
      self.dtTable = $('#dtTable').DataTable({
        "processing": true,
        "serverSide": true,
        "autoWidth": false,
        "pageLength": 10,
        "dom": 'ltipr',
        "lengthMenu": [10, 25, 50, 100, 250],

        'language': {
          //'loadingRecords': 'Please wait - loading...',
          'processing': '<div class="sk-spinner sk-spinner-double-bounce">\n' +
              '                <div class="sk-double-bounce1"></div>\n' +
              '                <div class="sk-double-bounce2"></div>\n' +
              '              </div>'
        },
        "order": [[0, "desc"]],
        "ajax": {
          url: processingURL,
          type: "post",
          data: function (d) {
            return JSON.stringify(d);
          },
          headers: {
            "Content-type": "application/json; charset=utf-8"
          },
          beforeSend: (xhr) => {
            xhr.setRequestHeader('Authorization', 'Bearer ' + this.$store.state.accessToken);
          },
          statusCode: {
            401: () => {
              this.updateRefreshTokenInDataTable(this.dtTable);
            }
          }
        },
        "columnDefs": [
          {"orderable": false, "targets": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]},
          {'className': "text-center", 'aTargets': [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]},
        ],
        "columns": [
          {"data": "id", "name": "id"},
          {"data": "customer.name", "name": "fullName"},
          {"data": "customer.contact1", "name": "contact1"},
          {
            "data": "customer.email", "name": "email",
            render: function (data) {
              if (data) {
                return  data
              } else {
                return "N/A"
              }
            }
          },
          {"data": "restaurant.name", "name": "restaurant"},
          {"data": "branch.areasByAreaId.name", "name": "branch"},
          {"data": "totalPersons", "name": "totalPersons"},
          {
            "data": "specialRequest", "name": "specialRequest",
            render: function (data) {
              if (data.length>50) {
                return  data.substring(0, 50)+'...'
              } else {
                return data ? data : 'N/A'
              }
            }
          },
          {
            "data": "reservationDate",
            "name": "reservationDate",
            "render": function (data) {
              return "<span class='m_tip label label-default'>"+self.formatDate(String(data))+"</span>";
            }
          },
          {
            "data": "created",
            "name": "created",
            "render": function (data) {
              return "<span class='m_tip label label-default'>"+self.formatDate(String(data))+"</span>";
            }
          },
          {
            "data": "modified",
            "name": "modified",
            "render": function (data) {
              return "<span class='m_tip label label-default'>"+self.formatDate(String(data))+"</span>";
            }
          },
          {
            "data": "status",
            "render": function(data, type, row){
              return "<span class='label "+row.status.cssClass+" update_status' data-id='" + row.id + "' data-current-status='"+row.status.id+"'>"+row.status.name+"</span>";
            },
            "name":"status"
          },
        ],
        "drawCallback": function () {
          $(".m_tip").tooltip();
          $(".update_status").click(function () {
            const reservationId = $(this).attr("data-id");
            const currentStatus = $(this).attr("data-current-status");
            console.log(currentStatus)

            self.$refs.changeReservationStatus.load(reservationId, currentStatus)
          });
        }
      });
      $.fn.dataTable.ext.errMode = 'none';
      let dtTableFilterSelector = $("#dtTable_filter input");
      dtTableFilterSelector.unbind();
      dtTableFilterSelector.attr("size", "35");
      dtTableFilterSelector.attr("placeholder", "Search on name , contact or username....");
      dtTableFilterSelector.keyup(function (e) {
        if (e.keyCode === 13) {
          self.dtTable.search($(this).val()).draw();
        }
      });
    },

  }
}
</script>

<style scoped>

</style>